import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { EntryPoint, EntryPointService, MagnetService } from '@mirage-projects/cw-commons';
import { CommonsConfigEnvironment, CONFIG_ENVIRONMENT } from '@mirage-projects/cw-models';

/**
 * Service to interact with different aspects of the Magnet Platform.
 */
@Injectable({
    providedIn: 'root',
})
export class AppMagnetService extends MagnetService {
    constructor(
        @Inject(CONFIG_ENVIRONMENT) protected configEnvironment: CommonsConfigEnvironment,
        @Inject('locationObject') protected location: Location,
        private http: HttpClient,
        private entryPointService: EntryPointService
    ) {
        super(configEnvironment, location);
    }

    /**
     * Get the diagnostics file data to be sent to the support user
     * @param projectId Id of the project that need support
     * @param params Object with a durationDays property with the days that the support inmpersonation will be allowed
     */
    getDiagnosticsFile(projectId: number, params: { durationDays: number }): Observable<Record<string, unknown>> {
        const entryPoint = this.entryPointService.getResource(EntryPoint.PROJECTS);
        const diagnosticFileUrl = `${entryPoint}${projectId}/diagnostic`;

        return this.http.post<Record<string, unknown>>(diagnosticFileUrl, params);
    }
}
